import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const CardiometabolicSugarMetabolismDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const slc2a2 = getGenePalette(geneColors.SLC2A2);
  const gck = getGenePalette(geneColors.GCK);
  const slc30a8 = getGenePalette(geneColors.SLC30A8);
  const tcf7l2 = getGenePalette(geneColors.TCF7L2);
  const irs1 = getGenePalette(geneColors.IRS1);
  const pparg = getGenePalette(geneColors.PPARG);
  const ppara = getGenePalette(geneColors.PPARA);
  const adrb2 = getGenePalette(geneColors.ADRB2);
  const ampd1 = getGenePalette(geneColors.AMPD1);
  const fto = getGenePalette(geneColors.FTO);
  const adipoq = getGenePalette(geneColors.ADIPOQ);
  const adrb3 = getGenePalette(geneColors.ADRB3);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18306_241217)">
        <rect width={1024} height={1288} transform="translate(0 170)" fill="white" />
        <g id="cardiometobolic-sugar metabolism-diagram">
          <rect width={1024} height={1288} transform="translate(0 170)" fill="white" />
          <rect
            id="Rectangle 465"
            x={498}
            y={216}
            width={505}
            height={232}
            stroke="#818181"
            strokeWidth={1.4}
          />
          <path
            id="Vector_4"
            d="M520 1221L513 1216.96V1225.04L520 1221ZM393 1221V1221.7H395.33V1221V1220.3H393V1221ZM395.33 1221V1221.7H513.7V1221V1220.3H395.33V1221Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_5"
            d="M130 1069L137 1073.04L137 1064.96L130 1069ZM316.675 1069L316.675 1069.7H316.675L316.675 1069ZM319 1069L319 1068.3L316.675 1068.3L316.675 1069L316.675 1069.7L319 1069.7L319 1069ZM316.675 1069L316.675 1068.3L136.3 1068.3L136.3 1069L136.3 1069.7L316.675 1069.7L316.675 1069Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_6"
            d="M520 1349L513 1344.96V1353.04L520 1349ZM393 1349V1349.7H395.33V1349V1348.3H393V1349ZM395.33 1349V1349.7H513.7V1349V1348.3H395.33V1349Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_7"
            d="M715 1349L708 1344.96V1353.04L715 1349ZM629 1349V1349.7H631.32V1349V1348.3H629V1349ZM631.32 1349V1349.7H708.7V1349V1348.3H631.32V1349Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_8"
            d="M885 1349L878 1344.96V1353.04L885 1349ZM799 1349V1349.7H801.32V1349V1348.3H799V1349ZM801.32 1349V1349.7H878.7V1349V1348.3H801.32V1349Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_9"
            d="M905 1357L909.041 1350L900.959 1350L905 1357ZM905 1339L904.3 1339L904.3 1339L905 1339ZM905 1339L904.3 1339L904.3 1339L905 1339L905.7 1339L905.7 1339L905 1339ZM905 1339L904.3 1339L904.3 1350.7L905 1350.7L905.7 1350.7L905.7 1339L905 1339Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_10"
            d="M762 1221L755 1216.96V1225.04L762 1221ZM635 1221V1221.7H637.33V1221V1220.3H635V1221ZM637.33 1221V1221.7H755.7V1221V1220.3H637.33V1221Z"
            fill="#1A1A1A"
          />
          <path id="Vector_11" d="M567 1069H583.241H708" stroke="#1A1A1A" strokeWidth={1.4} />
          <path id="Vector_12" d="M361 1069H363.33H488" stroke="#1A1A1A" strokeWidth={1.4} />
          <path
            id="Vector_13"
            d="M590 1221L583 1216.96V1225.04L590 1221ZM569 1221V1221.7H583.7V1221V1220.3H569V1221Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_14"
            d="M116 264L109 259.959V268.041L116 264ZM93 264V264.7H109.7V264V263.3H93V264Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_15"
            d="M123 482.096L118.959 489.096L127.041 489.096L123 482.096ZM123 502.753L123.7 502.753L123.7 488.396L123 488.396L122.3 488.396L122.3 502.753L123 502.753Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_16"
            d="M942.192 482.093L938.151 489.093L946.234 489.093L942.192 482.093ZM942.192 502.75L942.892 502.75L942.892 488.393L942.192 488.393L941.492 488.393L941.492 502.75L942.192 502.75Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_17"
            d="M940.237 587.984L936.196 594.984L944.279 594.984L940.237 587.984ZM940.237 608.641L940.937 608.641L940.937 594.284L940.237 594.284L939.537 594.284L939.537 608.641L940.237 608.641Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_18"
            d="M955 505L950.959 512L959.041 512L955 505ZM955 584L955.7 584L955.7 511.3L955 511.3L954.3 511.3L954.3 584L955 584Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_19"
            d="M955 612L950.959 619L959.041 619L955 612ZM955 1035L955.7 1035L955.7 618.3L955 618.3L954.3 618.3L954.3 1035L955 1035Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_20"
            d="M479 503L483.041 496L474.959 496L479 503ZM479 482L478.3 482L478.3 496.7L479 496.7L479.7 496.7L479.7 482L479 482Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_21"
            d="M498 266L491 261.959V270.041L498 266ZM461.404 351.703V352.403H462.104V351.703H461.404ZM153 351.703V351.003H152.3V351.703H153ZM153 470L157.041 463H148.959L153 470ZM245.794 266V266.7L461.404 266.7V266V265.3L245.794 265.3V266ZM461.404 266V266.7H491.7V266V265.3H461.404V266ZM461.404 266H460.704V351.703H461.404H462.104V266H461.404ZM461.404 351.703V351.003L153 351.003V351.703V352.403L461.404 352.403V351.703ZM153 351.703H152.3L152.3 463.7H153H153.7L153.7 351.703H153Z"
            fill="#1A1A1A"
          />
          <g id="lines_3">
            <path
              id="Vector_22"
              d="M573.7 264.342H573L573 265.742H573.7L573.7 265.042L573.7 264.342ZM690 265.042L683 261L683 269.083L690 265.042ZM573.7 265.042L573.7 265.742L683.7 265.742L683.7 265.042L683.7 264.342L573.7 264.342L573.7 265.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_23"
              d="M29.5 460.5L1002.5 460.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469">
              <text
                id="Section Divider SubLabel"
                transform="translate(29 461)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  Blood
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_5">
            <path
              id="Vector_24"
              d="M29.5 633.5L1002.5 633.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_2">
              <text
                id="Section Divider SubLabel_2"
                transform="translate(29 634)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  Peripheral tissue
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_6">
            <path
              id="Vector_25"
              d="M29.5 967.5L1002.5 967.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_26"
              d="M29.5 1164.5L1002.5 1164.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_3">
              <text
                id="Section Divider SubLabel_3"
                transform="translate(29 1165)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  Muscle
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_8">
            <path
              id="Vector_27"
              d="M29.5 1275.5L1002.5 1275.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_4">
              <text
                id="Section Divider SubLabel_4"
                transform="translate(29 1276)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  Muscle/Brain/ Neurons/Adipose tissue
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_9">
            <path
              id="Vector_28"
              d="M772.7 259.342H772L772 260.742H772.7L772.7 260.042L772.7 259.342ZM889 260.042L882 256L882 264.083L889 260.042ZM772.7 260.042L772.7 260.742L882.7 260.742L882.7 260.042L882.7 259.342L772.7 259.342L772.7 260.042Z"
              fill="#1A1A1A"
            />
          </g>
          <path
            id="Vector_29"
            d="M550 494L557 498.041L557 489.959L550 494ZM612 494L612 493.3L556.3 493.3L556.3 494L556.3 494.7L612 494.7L612 494Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_30"
            d="M641 343V342.3H640.3L640.3 343L641 343ZM641 474L645.041 467H636.959L641 474ZM641 343V343.7L827 343.7V343V342.3L641 342.3V343ZM641 343L640.3 343L640.3 467.7H641H641.7L641.7 343L641 343Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_31"
            d="M889 327L893.041 320L884.959 320L889 327ZM930 286.901L930 287.601L930.7 287.601L930.7 286.901L930 286.901ZM889 286.901L889 286.201L888.3 286.201L888.3 286.901L889 286.901ZM930 280L929.3 280L929.3 286.901L930 286.901L930.7 286.901L930.7 280L930 280ZM930 286.901L930 286.201L889 286.201L889 286.901L889 287.601L930 287.601L930 286.901ZM889 286.901L888.3 286.901L888.3 320.7L889 320.7L889.7 320.7L889.7 286.901L889 286.901Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 305"
            d="M757 393.112L757 393.812L756.3 393.812L756.3 393.112L757 393.112ZM757 343L761.041 350L752.959 350L757 343ZM815 393.112L815 392.412L815.7 392.412L815.7 393.112L815 393.112ZM757 393.112L756.3 393.112L756.3 349.3L757 349.3L757.7 349.3L757.7 393.112L757 393.112ZM757 393.112L757 392.412L815 392.412L815 393.112L815 393.812L757 393.812L757 393.112ZM815 393.112L815.7 393.112L815.7 410L815 410L814.3 410L814.3 393.112L815 393.112Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 306"
            d="M745 393.202L745 393.902L745.7 393.902L745.7 393.202L745 393.202ZM745 343L740.959 350L749.041 350L745 343ZM687 393.202L687 392.502L686.3 392.502L686.3 393.202L687 393.202ZM745 393.202L745.7 393.202L745.7 349.3L745 349.3L744.3 349.3L744.3 393.202L745 393.202ZM745 393.202L745 392.502L687 392.502L687 393.202L687 393.902L745 393.902L745 393.202ZM687 393.202L686.3 393.202L686.3 410L687 410L687.7 410L687.7 393.202L687 393.202Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 307"
            d="M382 679.674L381.997 678.974L381.3 678.977L381.3 679.674L382 679.674ZM382 701L386.041 694L377.959 694L382 701ZM578 678.824L578.003 679.524L578.7 679.521L578.7 678.824L578 678.824ZM382 679.674L381.3 679.674L381.3 694.7L382 694.7L382.7 694.7L382.7 679.674L382 679.674ZM382 679.674L382.003 680.374L578.003 679.524L578 678.824L577.997 678.124L381.997 678.974L382 679.674ZM578 678.824L578.7 678.824L578.7 502L578 502L577.3 502L577.3 678.824L578 678.824Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 308"
            d="M806.519 1061L806.519 677.825L590 677.824L590 502M806.519 1061L799.792 1061M806.519 1061L813 1061"
            stroke="#E44C4B"
            strokeWidth={1.4}
          />
          <path
            id="Vector_32"
            d="M720 478L715.959 485L724.041 485L720 478ZM720 499L720.7 499L720.7 484.3L720 484.3L719.3 484.3L719.3 499L720 499Z"
            fill="#1A1A1A"
          />
          <path
            id="Ellipse 4"
            d="M754.516 515.193L754.208 514.564V514.564L754.516 515.193ZM639 502L639.493 510.068L646.233 505.607L639 502ZM771 506.201C770.61 505.619 770.61 505.619 770.61 505.619C770.61 505.619 770.611 505.619 770.611 505.619C770.611 505.619 770.611 505.619 770.611 505.619C770.611 505.619 770.61 505.619 770.61 505.619C770.61 505.619 770.61 505.619 770.609 505.62C770.608 505.62 770.607 505.621 770.605 505.623C770.6 505.626 770.593 505.631 770.583 505.637C770.564 505.65 770.535 505.669 770.495 505.695C770.416 505.747 770.295 505.825 770.133 505.928C769.808 506.135 769.315 506.442 768.65 506.842L769.011 507.442L769.372 508.042C770.047 507.636 770.549 507.322 770.883 507.11C771.051 507.003 771.176 506.922 771.26 506.867C771.302 506.84 771.334 506.819 771.356 506.805C771.366 506.798 771.375 506.792 771.38 506.788C771.383 506.787 771.385 506.785 771.387 506.784C771.388 506.784 771.388 506.783 771.389 506.783C771.389 506.783 771.389 506.783 771.389 506.782C771.389 506.782 771.389 506.782 771.389 506.782C771.389 506.782 771.389 506.782 771.39 506.782C771.39 506.782 771.39 506.782 771 506.201ZM764.942 509.786L764.603 509.174C763.413 509.834 762.042 510.577 760.482 511.394L760.807 512.014L761.132 512.634C762.701 511.812 764.083 511.064 765.282 510.399L764.942 509.786ZM756.622 514.153L756.31 513.526C755.634 513.864 754.934 514.21 754.208 514.564L754.516 515.193L754.823 515.822C755.552 515.466 756.256 515.118 756.935 514.779L756.622 514.153ZM754.516 515.193L754.208 514.564C753.586 514.868 752.955 515.165 752.316 515.455L752.605 516.092L752.894 516.73C753.546 516.434 754.189 516.132 754.823 515.822L754.516 515.193ZM748.71 517.731L748.456 517.078C747.172 517.579 745.857 518.052 744.515 518.498L744.735 519.162L744.956 519.826C746.32 519.373 747.657 518.892 748.964 518.383L748.71 517.731ZM740.693 520.396L740.505 519.722C739.174 520.094 737.819 520.439 736.442 520.756L736.599 521.439L736.757 522.121C738.154 521.798 739.529 521.448 740.882 521.07L740.693 520.396ZM732.463 522.297L732.335 521.609C730.973 521.86 729.592 522.086 728.194 522.283L728.292 522.976L728.39 523.669C729.807 523.469 731.208 523.241 732.59 522.985L732.463 522.297ZM724.097 523.481L724.028 522.784C722.647 522.921 721.252 523.032 719.844 523.115L719.885 523.814L719.926 524.513C721.353 524.429 722.767 524.316 724.166 524.177L724.097 523.481ZM715.663 523.979L715.649 523.28C714.952 523.293 714.252 523.3 713.549 523.3L713.549 524L713.549 524.7C714.261 524.7 714.97 524.693 715.677 524.679L715.663 523.979ZM713.549 524L713.549 523.3C712.889 523.3 712.224 523.297 711.555 523.29L711.548 523.99L711.541 524.69C712.214 524.697 712.884 524.7 713.549 524.7L713.549 524ZM707.536 523.913L707.556 523.213C706.234 523.175 704.902 523.125 703.562 523.061L703.529 523.76L703.495 524.459C704.844 524.523 706.186 524.574 707.516 524.613L707.536 523.913ZM699.522 523.532L699.568 522.834C698.243 522.746 696.913 522.645 695.582 522.531L695.523 523.229L695.463 523.926C696.803 524.041 698.141 524.142 699.475 524.231L699.522 523.532ZM691.529 522.848L691.602 522.152C690.276 522.012 688.952 521.859 687.631 521.692L687.544 522.387L687.456 523.081C688.786 523.249 690.12 523.403 691.456 523.544L691.529 522.848ZM683.569 521.841L683.672 521.148C682.349 520.951 681.034 520.74 679.729 520.515L679.61 521.205L679.491 521.894C680.807 522.122 682.133 522.335 683.466 522.533L683.569 521.841ZM675.664 520.471L675.801 519.784C674.485 519.522 673.184 519.243 671.901 518.949L671.745 519.631L671.588 520.313C672.885 520.611 674.199 520.892 675.527 521.157L675.664 520.471ZM667.845 518.671L668.024 517.995C666.722 517.651 665.445 517.29 664.194 516.911L663.991 517.581L663.788 518.251C665.056 518.635 666.35 519.001 667.667 519.348L667.845 518.671ZM660.172 516.335L660.403 515.674C659.127 515.227 657.888 514.758 656.688 514.267L656.423 514.915L656.158 515.562C657.381 516.063 658.643 516.54 659.94 516.995L660.172 516.335ZM652.761 513.285L653.065 512.655C651.842 512.063 650.674 511.444 649.568 510.798L649.215 511.403L648.862 512.007C650.002 512.673 651.202 513.309 652.456 513.916L652.761 513.285ZM645.853 509.216L646.264 508.65C645.168 507.852 644.16 507.02 643.249 506.153L642.766 506.66L642.284 507.167C643.244 508.081 644.3 508.952 645.441 509.782L645.853 509.216ZM754.516 515.193L754.208 514.564V514.564L754.516 515.193ZM639 502L639.493 510.068L646.233 505.607L639 502ZM771 506.201C770.61 505.619 770.61 505.619 770.61 505.619C770.61 505.619 770.611 505.619 770.611 505.619C770.611 505.619 770.611 505.619 770.611 505.619C770.611 505.619 770.61 505.619 770.61 505.619C770.61 505.619 770.61 505.619 770.609 505.62C770.608 505.62 770.607 505.621 770.605 505.623C770.6 505.626 770.593 505.631 770.583 505.637C770.564 505.65 770.535 505.669 770.495 505.695C770.416 505.747 770.295 505.825 770.133 505.928C769.808 506.135 769.315 506.442 768.65 506.842L769.011 507.442L769.372 508.042C770.047 507.636 770.549 507.322 770.883 507.11C771.051 507.003 771.176 506.922 771.26 506.867C771.302 506.84 771.334 506.819 771.356 506.805C771.366 506.798 771.375 506.792 771.38 506.788C771.383 506.787 771.385 506.785 771.387 506.784C771.388 506.784 771.388 506.783 771.389 506.783C771.389 506.783 771.389 506.783 771.389 506.782C771.389 506.782 771.389 506.782 771.389 506.782C771.389 506.782 771.389 506.782 771.39 506.782C771.39 506.782 771.39 506.782 771 506.201ZM764.942 509.786L764.603 509.174C763.413 509.834 762.042 510.577 760.482 511.394L760.807 512.014L761.132 512.634C762.701 511.812 764.083 511.064 765.282 510.399L764.942 509.786ZM756.622 514.153L756.31 513.526C755.634 513.864 754.934 514.21 754.208 514.564L754.516 515.193L754.823 515.822C755.552 515.466 756.256 515.118 756.935 514.779L756.622 514.153ZM754.516 515.193L754.208 514.564C753.586 514.868 752.955 515.165 752.316 515.455L752.605 516.092L752.894 516.73C753.546 516.434 754.189 516.132 754.823 515.822L754.516 515.193ZM748.71 517.731L748.456 517.078C747.172 517.579 745.857 518.052 744.515 518.498L744.735 519.162L744.956 519.826C746.32 519.373 747.657 518.892 748.964 518.383L748.71 517.731ZM740.693 520.396L740.505 519.722C739.174 520.094 737.819 520.439 736.442 520.756L736.599 521.439L736.757 522.121C738.154 521.798 739.529 521.448 740.882 521.07L740.693 520.396ZM732.463 522.297L732.335 521.609C730.973 521.86 729.592 522.086 728.194 522.283L728.292 522.976L728.39 523.669C729.807 523.469 731.208 523.241 732.59 522.985L732.463 522.297ZM724.097 523.481L724.028 522.784C722.647 522.921 721.252 523.032 719.844 523.115L719.885 523.814L719.926 524.513C721.353 524.429 722.767 524.316 724.166 524.177L724.097 523.481ZM715.663 523.979L715.649 523.28C714.952 523.293 714.252 523.3 713.549 523.3L713.549 524L713.549 524.7C714.261 524.7 714.97 524.693 715.677 524.679L715.663 523.979ZM713.549 524L713.549 523.3C712.889 523.3 712.224 523.297 711.555 523.29L711.548 523.99L711.541 524.69C712.214 524.697 712.884 524.7 713.549 524.7L713.549 524ZM707.536 523.913L707.556 523.213C706.234 523.175 704.902 523.125 703.562 523.061L703.529 523.76L703.495 524.459C704.844 524.523 706.186 524.574 707.516 524.613L707.536 523.913ZM699.522 523.532L699.568 522.834C698.243 522.746 696.913 522.645 695.582 522.531L695.523 523.229L695.463 523.926C696.803 524.041 698.141 524.142 699.475 524.231L699.522 523.532ZM691.529 522.848L691.602 522.152C690.276 522.012 688.952 521.859 687.631 521.692L687.544 522.387L687.456 523.081C688.786 523.249 690.12 523.403 691.456 523.544L691.529 522.848ZM683.569 521.841L683.672 521.148C682.349 520.951 681.034 520.74 679.729 520.515L679.61 521.205L679.491 521.894C680.807 522.122 682.133 522.335 683.466 522.533L683.569 521.841ZM675.664 520.471L675.801 519.784C674.485 519.522 673.184 519.243 671.901 518.949L671.745 519.631L671.588 520.313C672.885 520.611 674.199 520.892 675.527 521.157L675.664 520.471ZM667.845 518.671L668.024 517.995C666.722 517.651 665.445 517.29 664.194 516.911L663.991 517.581L663.788 518.251C665.056 518.635 666.35 519.001 667.667 519.348L667.845 518.671ZM660.172 516.335L660.403 515.674C659.127 515.227 657.888 514.758 656.688 514.267L656.423 514.915L656.158 515.562C657.381 516.063 658.643 516.54 659.94 516.995L660.172 516.335ZM652.761 513.285L653.065 512.655C651.842 512.063 650.674 511.444 649.568 510.798L649.215 511.403L648.862 512.007C650.002 512.673 651.202 513.309 652.456 513.916L652.761 513.285ZM645.853 509.216L646.264 508.65C645.168 507.852 644.16 507.02 643.249 506.153L642.766 506.66L642.284 507.167C643.244 508.081 644.3 508.952 645.441 509.782L645.853 509.216Z"
            fill="#818181"
          />
          <path
            id="Vector_33"
            d="M154 512L149.959 519L158.041 519L154 512ZM154 1015.87L154 1016.57L154.7 1016.57L154.7 1015.87L154 1015.87ZM93 1015.87L93 1015.17L92.3 1015.17L92.3 1015.87L93 1015.87ZM154 1015.87L154.7 1015.87L154.7 518.3L154 518.3L153.3 518.3L153.3 1015.87L154 1015.87ZM93 1054L93.7 1054L93.7 1015.87L93 1015.87L92.3 1015.87L92.3 1054L93 1054ZM93 1015.87L93 1016.57L154 1016.57L154 1015.87L154 1015.17L93 1015.17L93 1015.87Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_34"
            d="M383 924L378.959 917L387.041 917L383 924ZM383 729L383.7 729L383.7 917.7L383 917.7L382.3 917.7L382.3 729L383 729Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector_35"
            d="M309 312L304.959 319L313.041 319L309 312ZM309 819L308.3 819L308.3 819.7L309 819.7L309 819ZM362 819L362 819.7L362.7 819.7L362.7 819L362 819ZM309 819L309.7 819L309.7 318.3L309 318.3L308.3 318.3L308.3 819L309 819ZM362 819L362.7 819L362.7 792.343L362 792.343L361.3 792.343L361.3 819L362 819ZM309 819L309 819.7L362 819.7L362 819L362 818.3L309 818.3L309 819Z"
            fill="#1A1A1A"
          />
          <rect
            id="Rectangle 466"
            x={34}
            y={997}
            width={437}
            height={151}
            stroke="#818181"
            strokeWidth={1.4}
          />
          <rect
            id="Rectangle 467"
            x={582}
            y={997}
            width={419}
            height={151}
            stroke="#818181"
            strokeWidth={1.4}
          />
          <rect
            id="Rectangle 469"
            x={604}
            y={1044}
            width={389}
            height={90}
            stroke="#818181"
            strokeWidth={1.4}
            strokeDasharray="4 4"
          />
          <path
            id="Vector_36"
            d="M884 1069L877 1064.96V1073.04L884 1069ZM751 1069V1069.7H753.31V1069V1068.3H751V1069ZM753.31 1069V1069.7H877.7V1069V1068.3H753.31V1069Z"
            fill="#1A1A1A"
          />
          <rect
            id="Rectangle 468"
            x={42}
            y={1047}
            width={414}
            height={87}
            stroke="#818181"
            strokeWidth={1.4}
            strokeDasharray="4 4"
          />
          <path
            id="Vector 309"
            d="M405 819.556H404.3V820.256H405V819.556ZM704 819.556H704.7V818.856H704V819.556ZM704 1005L708.041 998H699.959L704 1005ZM405 800H404.3V819.556H405H405.7V800H405ZM704 819.556H703.3V998.7H704H704.7V819.556H704ZM405 819.556V820.256H704V819.556V818.856H405V819.556Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 310"
            d="M779 1020V1020.7H779.7V1020H779ZM779 506L774.959 513H783.041L779 506ZM779 1020H779.7V512.3H779H778.3V1020H779ZM703 1020V1020.7H741V1020V1019.3H703V1020ZM741 1020V1020.7H779V1020V1019.3H741V1020Z"
            fill="#1A1A1A"
          />
          <g id="gene-SLC2A2" {...geneGroupProps("SLC2A2", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M271 260C271 257.791 272.791 256 275 256H348C350.209 256 352 257.791 352 260V276C352 278.209 350.209 280 348 280H275C272.791 280 271 278.209 271 276V260Z"
                fill={slc2a2.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={287.417} y={272.767}>
                  SLC2A2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="slc2a2"
              groupId="gene-snps"
              genePalette={slc2a2}
              startX={279}
              startY={282}
              snpCount={getGeneSnpCount("SLC2A2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-GCK" {...geneGroupProps("GCK", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M577 231C577 228.791 578.791 227 581 227H653C655.209 227 657 228.791 657 231V247C657 249.209 655.209 251 653 251H581C578.791 251 577 249.209 577 247V231Z"
                fill={gck.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={602.187} y={243.767}>
                  GCK
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="gck"
              groupId="gene-snps_2"
              genePalette={gck}
              startX={585}
              startY={253}
              snpCount={getGeneSnpCount("GCK", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SLC30A8" {...geneGroupProps("SLC30A8", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M773 409C773 406.791 774.791 405 777 405H859C861.209 405 863 406.791 863 409V425C863 427.209 861.209 429 859 429H777C774.791 429 773 427.209 773 425V409Z"
                fill={slc30a8.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={789.494} y={421.767}>
                  SLC30A8
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="slc30a8"
              groupId="gene-snps_3"
              genePalette={slc30a8}
              startX={781}
              startY={431}
              snpCount={getGeneSnpCount("SLC30A8", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-TCF7L2" {...geneGroupProps("TCF7L2", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M647 409C647 406.791 648.791 405 651 405H723C725.209 405 727 406.791 727 409V425C727 427.209 725.209 429 723 429H651C648.791 429 647 427.209 647 425V409Z"
                fill={tcf7l2.lozengeFill}
              />
              <text
                id="gene-label_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={664.195} y={421.767}>
                  TCF7L2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="tcf7l2"
              groupId="gene-snps_4"
              genePalette={tcf7l2}
              startX={655}
              startY={431}
              snpCount={getGeneSnpCount("TCF7L2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-IRS1" {...geneGroupProps("IRS1", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M471 672C471 669.791 472.791 668 475 668H547C549.209 668 551 669.791 551 672V688C551 690.209 549.209 692 547 692H475C472.791 692 471 690.209 471 688V672Z"
                fill={irs1.lozengeFill}
              />
              <text
                id="gene-label_9"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={498.552} y={684.767}>
                  IRS1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="irs1"
              groupId="gene-snps_5"
              genePalette={irs1}
              startX={479}
              startY={694}
              snpCount={getGeneSnpCount("IRS1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PPARG" {...geneGroupProps("PPARG", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M346 780C346 777.791 347.791 776 350 776H422C424.209 776 426 777.791 426 780V796C426 798.209 424.209 800 422 800H350C347.791 800 346 798.209 346 796V780Z"
                fill={pparg.lozengeFill}
              />
              <text
                id="gene-label_10"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={363.968} y={792.767}>
                  PPARG
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="pparg"
              groupId="gene-snps_6"
              genePalette={pparg}
              startX={354}
              startY={802}
              snpCount={getGeneSnpCount("PPARG", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PPARA" {...geneGroupProps("PPARA", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M342 875C342 872.791 343.791 871 346 871H418C420.209 871 422 872.791 422 875V891C422 893.209 420.209 895 418 895H346C343.791 895 342 893.209 342 891V875Z"
                fill={ppara.lozengeFill}
              />
              <text
                id="gene-label_11"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={360.966} y={887.767}>
                  PPARA
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ppara"
              groupId="gene-snps_7"
              genePalette={ppara}
              startX={350}
              startY={897}
              snpCount={getGeneSnpCount("PPARA", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-PPARA_2" {...geneGroupProps("PPARA", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M342 875C342 872.791 343.791 871 346 871H418C420.209 871 422 872.791 422 875V891C422 893.209 420.209 895 418 895H346C343.791 895 342 893.209 342 891V875Z"
                fill={ppara.lozengeFill}
              />
              <text
                id="gene-label_12"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={360.966} y={887.767}>
                  PPARA
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ppara-2"
              groupId="gene-snps_8"
              genePalette={ppara}
              startX={350}
              startY={897}
              snpCount={getGeneSnpCount("PPARA", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ADRB2" {...geneGroupProps("ADRB2", onGeneClick)}>
            <g id="gene-lozenge_13">
              <path
                d="M299 1062C299 1059.79 300.791 1058 303 1058H375C377.209 1058 379 1059.79 379 1062V1078C379 1080.21 377.209 1082 375 1082H303C300.791 1082 299 1080.21 299 1078V1062Z"
                fill={adrb2.lozengeFill}
              />
              <text
                id="gene-label_13"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={317.398} y={1074.77}>
                  ADRB2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="adrb2"
              groupId="gene-snps_9"
              genePalette={adrb2}
              startX={307}
              startY={1084}
              snpCount={getGeneSnpCount("ADRB2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AMPD1" {...geneGroupProps("AMPD1", onGeneClick)}>
            <g id="gene-lozenge_14">
              <path
                d="M308 1211C308 1208.79 309.791 1207 312 1207H384C386.209 1207 388 1208.79 388 1211V1227C388 1229.21 386.209 1231 384 1231H312C309.791 1231 308 1229.21 308 1227V1211Z"
                fill={ampd1.lozengeFill}
              />
              <text
                id="gene-label_14"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={326.289} y={1223.77}>
                  AMPD1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ampd1"
              groupId="gene-snps_10"
              genePalette={ampd1}
              startX={316}
              startY={1233}
              snpCount={getGeneSnpCount("AMPD1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-FTO" {...geneGroupProps("FTO", onGeneClick)}>
            <g id="gene-lozenge_15">
              <path
                d="M308 1339C308 1336.79 309.791 1335 312 1335H384C386.209 1335 388 1336.79 388 1339V1355C388 1357.21 386.209 1359 384 1359H312C309.791 1359 308 1357.21 308 1355V1339Z"
                fill={fto.lozengeFill}
              />
              <text
                id="gene-label_15"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={335.292} y={1351.77}>
                  FTO
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fto"
              groupId="gene-snps_11"
              genePalette={fto}
              startX={316}
              startY={1361}
              snpCount={getGeneSnpCount("FTO", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ADIPOQ" {...geneGroupProps("ADIPOQ", onGeneClick)}>
            <g id="gene-lozenge_16">
              <path
                d="M664 1012C664 1009.79 665.791 1008 668 1008H746C748.209 1008 750 1009.79 750 1012V1028C750 1030.21 748.209 1032 746 1032H668C665.791 1032 664 1030.21 664 1028V1012Z"
                fill={adipoq.lozengeFill}
              />
              <text
                id="gene-label_16"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={680.449} y={1024.77}>
                  ADIPOQ
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="adipoq"
              groupId="gene-snps_12"
              genePalette={adipoq}
              startX={672}
              startY={1034}
              snpCount={getGeneSnpCount("ADIPOQ", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ADRB3" {...geneGroupProps("ADRB3", onGeneClick)}>
            <g id="gene-lozenge_17">
              <path
                d="M692 1059C692 1056.79 693.791 1055 696 1055H768C770.209 1055 772 1056.79 772 1059V1075C772 1077.21 770.209 1079 768 1079H696C693.791 1079 692 1077.21 692 1075V1059Z"
                fill={adrb3.lozengeFill}
              />
              <text
                id="gene-label_17"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={710.146} y={1071.77}>
                  ADRB3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="adrb3"
              groupId="gene-snps_13"
              genePalette={adrb3}
              startX={700}
              startY={1081}
              snpCount={getGeneSnpCount("ADRB3", expectedSnps, geneColors)}
            />
          </g>
          <g id="Report titles">
            <text
              id="25-Hydroxy Vitamin D"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={22} y={259.448}>
                Entry{" "}
              </tspan>
              <tspan x={22} y={287.448}>
                from diet
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={268} y={305.405}>
                GLUT2 transporter
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={131} y={229.405}>
                Gut
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={499} y={206.405}>
                Beta cells
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={515} y={270.086}>
                Glucose
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={585.438} y={289.405}>
                Adds phosphate{" "}
              </tspan>
              <tspan x={599.623} y={305.405}>
                to glucose
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={663.247} y={240.405}>
                (glucose sensor)
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={804.091} y={277.405}>
                (glycolysis)
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={898} y={301.405}>
                High ATP{" "}
              </tspan>
              <tspan x={898} y={317.405}>
                closes channel
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <text
              id="25-Hydroxy Vitamin D_10"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={763} y={360.405}>
                Packages{" "}
              </tspan>
              <tspan x={763} y={376.405}>
                insulin
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <text
              id="25-Hydroxy Vitamin D_11"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={385} y={654.405}>
                Insulin binds{" "}
              </tspan>
              <tspan x={385} y={670.405}>
                receptor
              </tspan>
            </text>
          </g>
          <g id="Report titles_12">
            <text
              id="25-Hydroxy Vitamin D_12"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={390} y={746.405}>
                Activation{" "}
              </tspan>
              <tspan x={390} y={762.405}>
                in muscle/liver/fat
              </tspan>
            </text>
          </g>
          <g id="Report titles_13">
            <text
              id="25-Hydroxy Vitamin D_13"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={428} y={793.405}>
                (Transcription factor)
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <text
              id="25-Hydroxy Vitamin D_14"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={661} y={811.405}>
                Turns on
              </tspan>
            </text>
          </g>
          <g id="Report titles_15">
            <text
              id="25-Hydroxy Vitamin D_15"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={426} y={886.405}>
                (Fatty acid oxidation regulator)
              </tspan>
            </text>
          </g>
          <g id="Report titles_16">
            <text
              id="25-Hydroxy Vitamin D_16"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={307.611} y={936.405}>
                Fat burning (for energy instead){" "}
              </tspan>
              <tspan x={306.303} y={952.405}>
                (Spares glucose -- Randle cycle)
              </tspan>
            </text>
          </g>
          <g id="Report titles_17">
            <text
              id="25-Hydroxy Vitamin D_17"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={319.408} y={844.405}>
                Coordinates{" "}
              </tspan>
              <tspan x={356.713} y={860.405}>
                with
              </tspan>
            </text>
          </g>
          <g id="Report titles_18">
            <text
              id="25-Hydroxy Vitamin D_18"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={34.8281} y={990.405}>
                Liver
              </tspan>
            </text>
          </g>
          <g id="Report titles_19">
            <text
              id="25-Hydroxy Vitamin D_19"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={584.945} y={990.405}>
                Adipose tissue
              </tspan>
            </text>
          </g>
          <g id="Report titles_20">
            <text
              id="25-Hydroxy Vitamin D_20"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={160.111} y={1083.4}>
                Triggers glycogenolysis
              </tspan>
            </text>
          </g>
          <g id="Report titles_21">
            <text
              id="25-Hydroxy Vitamin D_21"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={188.363} y={1111.4}>
                During stress/fasting.{" "}
              </tspan>
              <tspan x={167.064} y={1127.4}>
                For quick energy (fight or flight)
              </tspan>
            </text>
          </g>
          <g id="Report titles_22">
            <text
              id="25-Hydroxy Vitamin D_22"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={749.863} y={1111.4}>
                During stress/fasting.{" "}
              </tspan>
              <tspan x={682.158} y={1127.4}>
                For long-lasting energy (FFA compete with glucose)
              </tspan>
            </text>
          </g>
          <g id="Report titles_23">
            <text
              id="25-Hydroxy Vitamin D_23"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={65.457} y={1066.09}>
                Glycogen{" "}
              </tspan>
              <tspan x={61.0684} y={1082.09}>
                breakdown
              </tspan>
            </text>
          </g>
          <g id="Report titles_24">
            <text
              id="25-Hydroxy Vitamin D_24"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={71.0176} y={1228.09}>
                During exercise
              </tspan>
            </text>
          </g>
          <g id="Report titles_25">
            <text
              id="25-Hydroxy Vitamin D_25"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={535.277} y={1225.09}>
                AMP
              </tspan>
            </text>
          </g>
          <g id="Report titles_26">
            <text
              id="25-Hydroxy Vitamin D_26"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={603.174} y={1225.09}>
                IMP
              </tspan>
            </text>
          </g>
          <g id="Report titles_27">
            <text
              id="25-Hydroxy Vitamin D_27"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={770.328} y={1225.09}>
                Muscle glucose uptake
              </tspan>
            </text>
          </g>
          <g id="Report titles_28">
            <text
              id="25-Hydroxy Vitamin D_28"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={323.185} y={1199.4}>
                Activation
              </tspan>
            </text>
          </g>
          <g id="Report titles_29">
            <text
              id="25-Hydroxy Vitamin D_29"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={298.449} y={1256.4}>
                (muscle energy sensor)
              </tspan>
            </text>
          </g>
          <g id="Report titles_30">
            <text
              id="25-Hydroxy Vitamin D_30"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={431.385} y={1214.4}>
                Conversion
              </tspan>
            </text>
          </g>
          <g id="Report titles_31">
            <text
              id="25-Hydroxy Vitamin D_31"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={431.056} y={1340.4}>
                Regulates
              </tspan>
            </text>
          </g>
          <g id="Report titles_32">
            <text
              id="25-Hydroxy Vitamin D_32"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={656.038} y={1339.4}>
                Affects
              </tspan>
            </text>
          </g>
          <g id="Report titles_33">
            <text
              id="25-Hydroxy Vitamin D_33"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={823.44} y={1340.4}>
                Impacts
              </tspan>
            </text>
          </g>
          <g id="Report titles_34">
            <text
              id="25-Hydroxy Vitamin D_34"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={71} y={1344.09}>
                Long/term regulation{" "}
              </tspan>
              <tspan x={71} y={1360.09}>
                (problematic if in excess fat)
              </tspan>
            </text>
          </g>
          <g id="Report titles_35">
            <text
              id="25-Hydroxy Vitamin D_35"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={537.398} y={1354.09}>
                Energy intake
              </tspan>
            </text>
            <text
              id="Sub Label"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0em"
            >
              <tspan x={528.445} y={1368.4}>
                (how much one eats{" "}
              </tspan>
              <tspan x={534.881} y={1378.4}>
                and stores as fat)
              </tspan>
            </text>
          </g>
          <g id="Report titles_36">
            <text
              id="25-Hydroxy Vitamin D_36"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={731.318} y={1352.09}>
                Adiposity
              </tspan>
            </text>
            <text
              id="Sub Label_2"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0em"
            >
              <tspan x={734.651} y={1366.4}>
                (body fat)
              </tspan>
            </text>
          </g>
          <g id="Report titles_37">
            <text
              id="25-Hydroxy Vitamin D_37"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={925.525} y={1351.09}>
                {"Insulin "}
              </tspan>
              <tspan x={915.518} y={1367.09}>
                sensitivity
              </tspan>
            </text>
          </g>
          <g id="Report titles_38">
            <text
              id="25-Hydroxy Vitamin D_38"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={498.41} y={1072.09}>
                Adrenaline
              </tspan>
            </text>
          </g>
          <g id="Report titles_39">
            <text
              id="25-Hydroxy Vitamin D_39"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={890.393} y={1065.09}>
                Fat (triglycerides){" "}
              </tspan>
              <tspan x={905.293} y={1081.09}>
                break down
              </tspan>
            </text>
          </g>
          <g id="Report titles_40">
            <text
              id="25-Hydroxy Vitamin D_40"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={392.107} y={1061.4}>
                Binds
              </tspan>
            </text>
          </g>
          <g id="Report titles_41">
            <text
              id="25-Hydroxy Vitamin D_41"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={638.107} y={1062.4}>
                Binds
              </tspan>
            </text>
          </g>
          <g id="Report titles_42">
            <text
              id="25-Hydroxy Vitamin D_42"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={388.566} y={1084.4}>
                (in liver)
              </tspan>
            </text>
          </g>
          <g id="Report titles_43">
            <text
              id="25-Hydroxy Vitamin D_43"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={625.301} y={1085.4}>
                (in fat cells)
              </tspan>
            </text>
          </g>
          <g id="Report titles_44">
            <text
              id="25-Hydroxy Vitamin D_44"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={781.074} y={1085.4}>
                Triggers lipolysis
              </tspan>
            </text>
          </g>
          <g id="Report titles_45">
            <text
              id="25-Hydroxy Vitamin D_45"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={221.783} y={707.405}>
                {"Signals GLUT2 to "}
              </tspan>
              <tspan x={207.291} y={723.405}>
                {"move to cell surface "}
              </tspan>
              <tspan x={239.205} y={739.405}>
                {"and allow for "}
              </tspan>
              <tspan x={224.664} y={755.405}>
                {"glucose to enter "}
              </tspan>
              <tspan x={249.488} y={771.405}>
                cells again
              </tspan>
            </text>
          </g>
          <g id="Report titles_46">
            <text
              id="25-Hydroxy Vitamin D_46"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={687.111} y={360.405}>
                Regulates{" "}
              </tspan>
              <tspan x={660.412} y={376.405}>
                insulin secretion
              </tspan>
            </text>
          </g>
          <g id="Report titles_47">
            <text
              id="25-Hydroxy Vitamin D_47"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={648.217} y={540.405}>
                {"Overall insulin sensitivity "}
              </tspan>
              <tspan x={670.224} y={556.405}>
                {"enhancement "}{" "}
              </tspan>
              <tspan x={659.545} y={572.405}>
                (positive feedback)
              </tspan>
            </text>
          </g>
          <g id="Report titles_48">
            <text
              id="25-Hydroxy Vitamin D_48"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={879.021} y={549.405}>
                Contributes to
              </tspan>
            </text>
          </g>
          <g id="Report titles_49">
            <text
              id="25-Hydroxy Vitamin D_49"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={794.394} y={251.405}>
                G6P breakdown
              </tspan>
            </text>
          </g>
          <g id="Report titles_50">
            <text
              id="25-Hydroxy Vitamin D_50"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={697.18} y={261.086}>
                Glucose-6-P{" "}
              </tspan>
              <tspan x={717.641} y={277.086}>
                (G6P)
              </tspan>
            </text>
          </g>
          <g id="Report titles_51">
            <text
              id="25-Hydroxy Vitamin D_51"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={493.494} y={498.098}>
                Glucose
              </tspan>
            </text>
          </g>
          <g id="Report titles_52">
            <text
              id="25-Hydroxy Vitamin D_52"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={130.494} y={498.098}>
                Glucose
              </tspan>
            </text>
          </g>
          <g id="Report titles_53">
            <text
              id="25-Hydroxy Vitamin D_53"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={343.432} y={719.086}>
                IRS1-bound insulin
              </tspan>
            </text>
          </g>
          <g id="Report titles_54">
            <text
              id="25-Hydroxy Vitamin D_54"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={626.281} y={495.098}>
                Insulin
              </tspan>
            </text>
          </g>
          <g id="Report titles_55">
            <text
              id="25-Hydroxy Vitamin D_55"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={726.295} y={495.098}>
                Adiponectin release
              </tspan>
            </text>
          </g>
          <g id="Report titles_56">
            <text
              id="25-Hydroxy Vitamin D_56"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={947.289} y={499.098}>
                TG
              </tspan>
            </text>
          </g>
          <g id="Report titles_57">
            <text
              id="25-Hydroxy Vitamin D_57"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={947.457} y={602.098}>
                FFA
              </tspan>
            </text>
          </g>
          <g id="Report titles_58">
            <text
              id="25-Hydroxy Vitamin D_58"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={919.17} y={260.086}>
                ATP{" "}
              </tspan>
              <tspan x={875.33} y={276.086}>
                (energy production)
              </tspan>
            </text>
          </g>
          <g id="Report titles_59">
            <text
              id="25-Hydroxy Vitamin D_59"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={835.066} y={343.086}>
                Cell depolarises{" "}
              </tspan>
              <tspan x={837.035} y={359.086}>
                & Ca2+ influxes
              </tspan>
            </text>
          </g>
          <g id="Report titles_60">
            <rect x={128.5} y={236.5} width={106} height={55} stroke="#818181" />
            <text
              id="25-Hydroxy Vitamin D_60"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={140.004} y={260.086}>
                Carbohydrates{" "}
              </tspan>
              <tspan x={156.012} y={276.086}>
                digestion
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgCardiometabolicSugarMetabolismDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1288}
    viewBox="0 170 1024 1288"
    fill="none"
    {...props}
  >
    <CardiometabolicSugarMetabolismDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18306_241217">
        <rect width={1024} height={1458} fill="white" />
      </clipPath>
      <clipPath id="clip1_18306_241217">
        <rect width={1024} height={1288} fill="white" transform="translate(0 170)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCardiometabolicSugarMetabolismDiagram;
